import { j as u } from "./jsx-runtime-DmTjM30f.mjs";
import { I as M } from "./ic_arrowmore_fill-t069C13c.mjs";
import { createContext as X, useContext as Y, useState as R, useMemo as K, useEffect as C, useRef as j, useCallback as I, forwardRef as E, isValidElement as ee, cloneElement as te } from "react";
import { e as W } from "./extract-responsive-property-BiJ5BiwI.mjs";
import { c as O } from "./tw-cn-mXgPecoF.mjs";
import { c as y } from "./index-BpNK5r1N.mjs";
import { o as B } from "./index-CcECYkhV.mjs";
import { I as re } from "./ic_arrowless_fill-EoSHNXJu.mjs";
const F = y(["relative w-full bg-static-white select-none"]), L = y(
  [
    "relative flex w-full min-h-32 py-4 px-16 items-center cursor-pointer !truncate",
    "border border-line-neutral-weak3 overflow-hidden rounded-8",
    "bg-static-white text-text-neutral-main placeholder:text-text-neutral-main",
    "hover-never:bg-interaction-neutral-presshover-weak1 active:bg-interaction-neutral-presshover-weak1",
    "disabled:bg-fill-neutral-weak disabled:cursor-not-allowed",
    "disabled:text-interaction-neutral-disable-main disabled:hover-never:bg-fill-neutral-weak",
    "disabled:placeholder:text-interaction-neutral-disable-main disabled:hover-never:place-holder:bg-fill-neutral-weak"
  ],
  {
    variants: {
      open: {
        true: "rounded-b-none border-b-0",
        false: ""
      },
      selected: {
        true: "!font-bold text-text-neutral-main",
        false: "text-text-neutral-sub"
      },
      size: {
        small: "h-32 typography-body-12-regular pr-36",
        medium: "h-44 typography-subtitle-16-regular pr-40"
      },
      pcSize: {
        small: "pc:h-32 pc:typography-body-12-regular pc:pr-36",
        medium: "pc:h-44 pc:typography-subtitle-16-regular pc:pr-40"
      }
    }
  }
), H = y(
  [
    "absolute right-16 top-1/2 size-16 -translate-y-1/2 pointer-events-none",
    "aria-disabled:text-interaction-neutral-disable-main"
  ],
  {
    variants: {
      open: {
        true: "rotate-180",
        false: ""
      },
      size: {
        small: "size-16",
        medium: "size-20"
      },
      pcSize: {
        small: "pc:size-16",
        medium: "pc:size-20"
      },
      disabled: {
        true: "hidden",
        false: ""
      }
    }
  }
), ne = y(
  ["absolute w-full rounded-b-8 border border-line-neutral-weak3 bg-static-white", "absolute border-t-0 "],
  {
    variants: {
      size: {
        small: "top-32",
        medium: "top-44"
      },
      pcSize: {
        small: "pc:top-32",
        medium: "pc:top-44"
      }
    }
  }
), ae = y(
  ["flex py-4 px-20 items-center cursor-pointer", "hover:bg-interaction-neutral-presshover-weak1"],
  {
    variants: {
      size: {
        small: "min-h-32 typography-body-12-regular",
        medium: "min-h-44 typography-subtitle-16-regular"
      },
      pcSize: {
        small: "pc:min-h-32 pc:typography-body-12-regular",
        medium: "pc:min-h-44 pc:typography-subtitle-16-regular"
      }
    }
  }
), oe = (e) => {
  const { value: a, size: o, className: i, ...t } = e, n = W({
    property: o,
    mobileKey: "size",
    pcKey: "pcSize",
    defaultValue: { mobile: "small", pc: "medium" }
  }), s = F(), r = L({ ...n, selected: !!a }), l = H({ ...n, disabled: t.disabled });
  return /* @__PURE__ */ u.jsxs("div", { className: O("relative", s, i), children: [
    /* @__PURE__ */ u.jsx("input", { ...t, className: r, readOnly: !0, value: a }),
    /* @__PURE__ */ u.jsx(M, { "aria-disabled": t.disabled, className: l })
  ] });
};
oe.displayName = "NDS.SelectboxButton";
const _ = X(null);
function V() {
  const e = Y(_);
  if (e === null)
    throw new Error("useSelectContext must be used within a SelectProvider");
  return e;
}
function se({
  open: e,
  value: a,
  size: o,
  candidateOption: i,
  onChangeValue: t,
  onChangeOpen: n,
  children: s
}) {
  const [r, l] = R({
    value: a,
    candidateOption: null,
    options: /* @__PURE__ */ new Map()
  }), p = W({
    property: o,
    mobileKey: "size",
    pcKey: "pcSize",
    defaultValue: { mobile: "small", pc: "medium" }
  }), b = K(
    () => ({
      onChangeOpen: n,
      onChangeValue: t,
      setOption(d, g) {
        l((c) => {
          const { options: h } = c, S = new Map(h);
          return S.set(d, { value: g }), { ...c, options: S };
        });
      },
      setCandidateOption(d) {
        l((g) => ({ ...g, candidateOption: d }));
      }
    }),
    [n, t]
  ), f = K(
    () => ({ ...r, open: !!e, ...p, ...b }),
    [r, e, b]
  );
  return C(() => {
    l((d) => ({ ...d, value: a, isOpen: !1 }));
  }, [a]), C(() => {
    e || l((d) => ({
      ...d,
      options: /* @__PURE__ */ new Map(),
      candidateOption: null
    }));
  }, [e]), /* @__PURE__ */ u.jsx(_.Provider, { value: f, children: s });
}
const q = ({ value: e, className: a, isCustom: o = !1, children: i }) => {
  const t = j(null), {
    value: n,
    candidateOption: s,
    setCandidateOption: r,
    size: l,
    pcSize: p,
    setOption: b,
    onChangeValue: f,
    onChangeOpen: d
  } = V(), g = ae({ size: l, pcSize: p }), c = n === e, h = s === t.current;
  C(() => {
    const k = t.current;
    b(k, e);
  }, [e, b]);
  const S = I(() => {
    f(e), d(!1);
  }, [e, f, d]), N = I(() => {
    const k = t.current;
    r(k);
  }, [r]);
  return /* @__PURE__ */ u.jsx(
    "li",
    {
      "aria-selected": c,
      className: o ? a : O(
        g,
        { "bg-interaction-neutral-presshover-weak1 !font-bold": c },
        { "bg-interaction-neutral-presshover-weak1": h },
        a
      ),
      onClick: S,
      onMouseEnter: N,
      ref: t,
      role: "option",
      tabIndex: -1,
      children: i
    }
  );
};
q.displayName = "NDS.DropdownOption";
const U = E(({ className: e, style: a, children: o }, i) => {
  const { open: t, size: n, pcSize: s } = V(), r = ne({ size: n, pcSize: s });
  return t ? /* @__PURE__ */ u.jsx("ul", { className: O(r, e), ref: i, style: a, children: o }) : null;
});
U.displayName = "NDS.DropdownOptions";
const Z = E((e, a) => {
  const { onClick: o, onKeyDown: i, ...t } = e, n = j(null), { value: s, options: r, candidateOption: l, open: p, size: b, pcSize: f, setCandidateOption: d, onChangeValue: g, onChangeOpen: c } = V(), h = L({ size: b, pcSize: f, open: p, selected: !!s }), S = H({ size: b, pcSize: f, open: p, disabled: t.disabled }), N = I(
    (v) => {
      c(!p), o == null || o(v);
    },
    [o, c, p]
  ), k = I(
    (v) => {
      if (v.preventDefault(), r.size === 0) return;
      const D = (w) => [...r].findIndex(([z]) => z === w);
      if (p)
        switch (v.code) {
          case "ArrowUp": {
            const w = D(l);
            if (w !== -1) {
              const x = (w - 1 + r.size) % r.size, z = [...r.keys()][x];
              d(z);
            } else {
              const x = [...r.keys()][0];
              d(x);
            }
            break;
          }
          case "ArrowDown": {
            const w = D(l);
            if (w !== -1) {
              const x = (w + 1) % r.size, z = [...r.keys()][x];
              d(z);
            } else {
              const x = [...r.keys()][0];
              d(x);
            }
            break;
          }
          case "Enter": {
            if (l === null) break;
            const { value: w } = r.get(l);
            g(w), c(!1);
            break;
          }
          case "Escape":
          case "Tab": {
            c(!1);
            break;
          }
        }
      else
        switch (v.code) {
          case "Enter":
          case "ArrowDown": {
            c(!0);
            break;
          }
        }
      i == null || i(v);
    },
    [r, l, p, d, i, g, c]
  );
  return /* @__PURE__ */ u.jsxs("div", { className: "relative", children: [
    /* @__PURE__ */ u.jsx(
      "input",
      {
        ...t,
        className: h,
        onClick: N,
        onFocus: () => {
          var v;
          return (v = n.current) == null ? void 0 : v.blur();
        },
        onKeyDown: k,
        readOnly: !0,
        ref: B([n, a])
      }
    ),
    /* @__PURE__ */ u.jsx(M, { "aria-disabled": t.disabled, className: S })
  ] });
});
Z.displayName = "NDS.DropdownTrigger";
const $ = E(({ children: e, className: a }, o) => {
  const i = j(null), { open: t, onChangeOpen: n } = V(), s = F();
  return C(() => {
    if (!t) return;
    const r = i.current, l = (p) => {
      const b = p.target;
      r.contains(b) || n(!1);
    };
    return document.addEventListener("click", l), () => {
      document.removeEventListener("click", l);
    };
  }, [t, n]), /* @__PURE__ */ u.jsx("div", { className: O(s, a), ref: B([i, o]), children: e });
});
$.displayName = "DropdownWrapper";
const le = (e) => {
  const {
    id: a,
    name: o,
    placeholder: i,
    defaultValue: t,
    value: n,
    options: s,
    required: r,
    disabled: l,
    size: p,
    optionZIndex: b = 10,
    customOptions: f,
    onFocus: d,
    onBlur: g,
    onChange: c,
    children: h,
    className: S,
    optionClassName: N
  } = e, k = j(null), v = j(null), [D, w] = R(!1), [x, z] = R(""), G = (m) => {
    w(m);
  }, A = () => {
    w(!1);
  };
  C(() => {
    const m = k.current, T = n || m.value || t || m.defaultValue;
    z(T);
  }, [n, t]), C(() => {
    var P;
    const m = k.current;
    (P = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set) == null || P.call(m, x || "");
    const Q = new Event("change", { bubbles: !0 });
    m.dispatchEvent(Q), m.focus();
  }, [x]);
  const J = () => s ? s.map(({ value: m, label: T }) => /* @__PURE__ */ u.jsx(q, { value: m, children: T }, m)) : f ? ie(f, A) : typeof h == "function" ? h({ onClose: A }) : h;
  return /* @__PURE__ */ u.jsx(
    se,
    {
      size: p,
      value: x,
      open: D,
      onChangeOpen: G,
      onChangeValue: z,
      children: /* @__PURE__ */ u.jsxs($, { className: S, ref: v, children: [
        /* @__PURE__ */ u.jsx(
          Z,
          {
            disabled: l,
            id: a,
            name: o,
            onBlur: g,
            onChange: (m) => {
              c == null || c(m);
            },
            onFocus: d,
            placeholder: i,
            readOnly: !0,
            ref: k,
            required: r
          }
        ),
        /* @__PURE__ */ u.jsx(U, { className: O("overflow-hidden", N), style: { zIndex: b }, children: J() })
      ] })
    }
  );
};
function ie(e, a) {
  return e ? e.map((o, i) => {
    if (!ee(o)) return o;
    const t = o, n = t.props.onClick;
    return te(t, {
      onClick: (s) => {
        n == null || n(s), a();
      },
      key: t.key ?? i
    });
  }) : null;
}
le.displayName = "NDS.Dropdown";
const ye = y(
  ["relative overflow-hidden", "border border-solid border-line-neutral-weak3", "rounded-b-8", "gap-4"],
  {
    variants: {
      isOpen: {
        true: "border-2 border-line-neutral-main border-t-0",
        false: ""
      }
    },
    defaultVariants: {
      isOpen: !1
    }
  }
), ke = y(["relative typography-subtitle-16-regular"], {
  variants: {
    isOpen: {
      true: "rounded-b-none",
      false: ""
    },
    disabled: {
      true: "!font-bold text-text-neutral-main",
      false: "text-text-neutral-sub"
    }
  }
}), de = y(
  [
    "relative flex w-full min-h-44 py-4 px-16 items-center cursor-pointer",
    "border border-line-neutral-weak3 overflow-hidden rounded-8",
    "typography-subtitle-16-regular",
    "bg-static-white text-text-neutral-main placeholder:text-text-neutral-main",
    "hover-never:bg-interaction-neutral-presshover-weak1 active:bg-interaction-neutral-presshover-weak1",
    "text-left",
    "disabled:bg-fill-neutral-weak disabled:cursor-not-allowed disabled:active:bg-fill-neutral-weak disabled:active:cursor-not-allowed",
    "disabled:text-interaction-neutral-disable-main disabled:hover-never:bg-fill-neutral-weak",
    "disabled:placeholder:text-interaction-neutral-disable-main disabled:hover-never:place-holder:bg-fill-neutral-weak"
  ],
  {
    variants: {
      isAccent: {
        true: "border-2 border-line-neutral-main",
        false: ""
      },
      isOpen: {
        true: "rounded-b-none border-2 border-line-neutral-main border-b-0",
        false: "before:hidden"
      },
      disabled: {
        true: "cursor-not-allowed",
        false: ""
      },
      hasDivider: {
        true: "before:absolute before:bottom-0 before:left-0 before:h-1 before:w-full before:bg-fill-neutral-weak3",
        false: ""
      }
    },
    defaultVariants: {
      isOpen: !1
    }
  }
), ce = y(
  ["aria-disabled:text-interaction-neutral-disable-main", "ml-auto shrink-0", "size-20"],
  {
    variants: {
      isOpen: {
        true: "",
        false: "rotate-180"
      },
      disabled: {
        true: "hidden",
        false: ""
      }
    }
  }
), ue = y(["mr-8 break-words"], {
  variants: {
    selected: {
      true: "text-text-neutral-main typography-subtitle-16-bold",
      false: "text-text-neutral-sub"
    },
    isAccent: {
      true: "",
      false: ""
    },
    disabled: {
      true: "cursor-not-allowed text-interaction-neutral-disable-main",
      false: ""
    },
    disabledAccent: {
      true: ["border-line-neutral-weak3 bg-fill-neutral-weak1", "text-text-neutral-sub typography-subtitle-16-bold"],
      false: ""
    }
  },
  defaultVariants: {
    //
  }
}), pe = E(
  ({
    value: e,
    isOpen: a,
    placeholder: o = "선택해 주세요",
    className: i,
    onClick: t,
    zIndex: n,
    isDisabled: s,
    isAccent: r,
    textClassName: l,
    needDisabledAccent: p,
    hasDivider: b
  }, f) => {
    const d = n ? `z-${n}` : "z-1", g = de({
      isOpen: a,
      isAccent: r,
      disabled: s,
      hasDivider: b
    }), c = ue({
      selected: !!e,
      disabled: s,
      isAccent: r,
      disabledAccent: p
    }), h = ce({ isOpen: a, disabled: s });
    return /* @__PURE__ */ u.jsxs(
      "button",
      {
        "aria-expanded": a,
        "aria-haspopup": "listbox",
        className: O(g, i, d),
        disabled: s,
        onClick: t,
        ref: f,
        type: "button",
        children: [
          /* @__PURE__ */ u.jsx("span", { className: O(c, l), children: e || o }),
          /* @__PURE__ */ u.jsx(re, { className: O(h) })
        ]
      }
    );
  }
);
pe.displayName = "PullDownTrigger";
export {
  le as D,
  pe as P,
  oe as S,
  ye as a,
  q as b,
  ke as p
};
